var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 9C3.77344 9.07031 3.46875 8.88281 3.375 8.60156C3.30469 8.29688 3.49219 7.99219 3.77344 7.89844L8.08594 6.77344C8.39062 6.70312 8.69531 6.89062 8.78906 7.17188C8.85938 7.47656 8.67188 7.78125 8.39062 7.875L4.07812 9ZM4.875 4.875C4.875 5.29688 4.54688 5.625 4.125 5.625C3.70312 5.625 3.375 5.29688 3.375 4.875C3.375 4.47656 3.70312 4.125 4.125 4.125C4.54688 4.125 4.875 4.47656 4.875 4.875ZM7.125 4.875C7.125 4.47656 7.45312 4.125 7.875 4.125C8.29688 4.125 8.625 4.47656 8.625 4.875C8.625 5.29688 8.29688 5.625 7.875 5.625C7.45312 5.625 7.125 5.29688 7.125 4.875ZM12 6C12 9.32812 9.30469 12 6 12C2.67188 12 0 9.32812 0 6C0 2.69531 2.67188 0 6 0C9.30469 0 12 2.69531 12 6ZM6 1.125C3.30469 1.125 1.125 3.32812 1.125 6C1.125 8.69531 3.30469 10.875 6 10.875C8.67188 10.875 10.875 8.69531 10.875 6C10.875 3.32812 8.67188 1.125 6 1.125Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.3daa1684e053851689c405e2a5f27722.svg";
export { ForwardRef as ReactComponent };